function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "BigQuery");

const SvgBq = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Layer_1",
  "data-name": "Layer 1",
  width: 128,
  height: 128,
  viewBox: "0 0 128 128",
  ref: svgRef
}, props), title === undefined ? _ref : title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
  d: "M126.47,58.12l-26.3-45.74A11.56,11.56,0,0,0,90.31,6.5H37.7a11.55,11.55,0,0,0-9.86,5.88L1.53,58a11.48,11.48,0,0,0,0,11.44l26.3,46a11.77,11.77,0,0,0,9.86,6.09H90.3a11.73,11.73,0,0,0,9.87-6.06l26.3-45.74A11.73,11.73,0,0,0,126.47,58.12Z",
  style: {
    fill: "#4285f4"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M100.17,115.44,117.7,84.95,80.62,47.88,64,43.43,49.07,49,43.3,64l4.64,16.73L88.71,121.5H90.3A11.73,11.73,0,0,0,100.17,115.44Z",
  style: {
    opacity: 0.070000000298023,
    isolation: "isolate"
  }
}), /*#__PURE__*/React.createElement("g", {
  id: "art"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M64,40.8A23.19,23.19,0,1,0,87.19,64,23.19,23.19,0,0,0,64,40.8M64,81.6A17.6,17.6,0,1,1,81.6,64,17.6,17.6,0,0,1,64,81.6",
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M53,63.1v7.21a12.79,12.79,0,0,0,4.38,4.48V63.1Z",
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M61.67,57V76.44a11.78,11.78,0,0,0,4.38,0V57Z",
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M70.77,66.1v8.56A12.78,12.78,0,0,0,75.15,70V66.1Z",
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M80.69,78.29l-2.4,2.41a1.09,1.09,0,0,0,0,1.53l9.11,9.11a1.09,1.09,0,0,0,1.54,0l2.4-2.4a1.09,1.09,0,0,0,0-1.53l-9.12-9.12a1.09,1.09,0,0,0-1.53,0",
  style: {
    fill: "#fff"
  }
}))));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBq, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/bq.3e7a8207.svg";
export { ForwardRef as ReactComponent };